import Button from "@mui/material/Button"
import { FormControlLabel, Grid2 as Grid, Switch } from "@mui/material"
import { Formik, Field } from "formik"
import { Documento } from "../../types"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormikTextField } from "./formsHelpers"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"

export default function DocumentoFormCatalogazione({ item, save, ref, language }: FormInDialogEditProps<Documento>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        titolo_attribuito: yup.string().test(function (value, ctx) {
          console.log(value, this.parent)
          const { titolo_proprio } = this.parent
          if (!titolo_proprio && !value) {
            ctx.createError({ message: t("documento.titolo_attribuito_or_proprio_required") })
          }
          return true
        }),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={
        item || {
          complemento_titolo: "",
          titolo_attribuito: "",
          note_titolo: "",
          abstract: "",
          notizie_stor_critiche: "",
          vincoli_modalita_consultazione: "",
          copyright: "",
          bibliografia_sitografia: "",
          limiti_utilizzo: false,
          data_produzione: null,
        }
      }
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Documento).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="titolo_attribuito"
                  label={t("documento.titolo_attribuito")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="note_titolo_it"
                    label={t("documento.note_titolo")}
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="note_titolo_en"
                    label={t("documento.note_titolo")}
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="abstract"
                  label={t("documento.abstract")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="notizie_stor_critiche_it"
                    label={t("documento.notizie_stor_critiche")}
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="notizie_stor_critiche_en"
                    label={t("documento.notizie_stor_critiche")}
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="vincoli_modalita_consultazione"
                  label={t("documento.vincoli_modalita_consultazione")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>

              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="copyright"
                  label={t("documento.copyright")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="bibliografia_sitografia_it"
                    label={t("documento.bibliografia_sitografia")}
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="bibliografia_sitografia_en"
                    label={t("documento.bibliografia_sitografia")}
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={values?.limiti_utilizzo}
                      onChange={(e) => setFieldValue("limiti_utilizzo", e.target.checked)}
                    />
                  }
                  label={t("documento.limiti_utilizzo")}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
